import React from 'react';
import { useSelector } from 'react-redux';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import DesignNameDialog from './DesignNameDialog';

const DesignName = () => {
	const userLoggedIn = useSelector(state => state.user.loggedIn);
	const userId = useSelector(state => state.user.id);
	const myDesign = useSelector(state => state.selectedDesign.myDesign);

	return (
		<Grid container alignItems="center" spacing={1}>
			<Grid item>
				<Typography display="inline" variant="subtitle1">
					{myDesign.name}
				</Typography>
			</Grid>

			{userLoggedIn && userId !== null ? (
				<Grid item>
					<DesignNameDialog />
				</Grid>
			) : null}
		</Grid>
	);
};

export default DesignName;
